module.exports = (require("./helpers/browser/import-polyfill")(require('./helpers/bundle-manifest').resolve("4fGj1"))).then(() => parcelRequire('1cezk'));